import { FallcoClass } from '../classes/FallcoClass';
import FallcoSettings  from './fallco_settings';

/**
 * Classe che estende le funzioni della scrittura nella console facendo un controllo sulla variabile "fallco.settings.debug".
 * Se questa variabile è impostata a false, evita che venga scritto qualsiasi cosa nella console, quindi silenzia le notifiche.
 *
 * @class
 * @extends FallcoClass
 */
class FallcoConsole extends FallcoClass {
  constructor() {
    super();
    
    this._styles = {
      log:   {},
      error: {},
      warn:  {}
    };

    // Setta dei valori di default per i log/gruppi log personalizzabili
    this.styleParams = 'padding: 5px 10px 5px 5px; border-radius:5px;';
    this.defaultBg = 'background:#069df7;';
    
    return super.expose_to_public('console', this);
  }
  
  /**
   * Esegue l'azione della console passata come "type" passando i parametri contenuti in "args".
   * Prima di eseguire l'azione richiesta controlla se esistono delle impostazioni globali e se queste hanno la proprietà "debug" = false.
   *
   * @param {string} type
   * @param {Array} message
   * @private
   */
  _writeToConsole(type, ...message) {
    if (FallcoSettings.debug === false) {
      return;
    }

    console[type]('[FC]', ...message);
  }

  _executeConsole(callback) {
    if (FallcoSettings.debug === false) {
      return;
    }

    callback()

  }
  
  /*
   _getStack() {
   const err            = new Error();
   let stack            = err.stack;
   let strToRemove      = stack.match(/^.*FallcoConsole.*$/gm).join('');
   let strToRemoveStart = stack.search(/^.*FallcoConsole.*$/gm);
   
   // return stack.slice(strToRemoveStart + strToRemove.length);
   
   return err;
   }
   */
  
  /**
   * @extends console.log
   */
  log(...message) {
    this._writeToConsole('log', ...message);
  }
  
  /**
   * @extends console.warn
   */
  warn(...optionalParams) {
    this._writeToConsole('warn', ...optionalParams);
  }

  /**
   * @extends console.info
   */
  info(...optionalParams) {
    this._writeToConsole('info', ...optionalParams);
  }
  
  /**
   * @extends console.error
   */
  error(...optionalParams) {
    this._writeToConsole('error', ...optionalParams);
  }

  /**
   * Imposta un log con uno stile personalizzato
   * @param message
   * @param style
   */
  custom_log(message, style) {
    style = (style) ? style : this.defaultBg;
    style += this.styleParams;
    this._executeConsole(function(){console.log('%c [FC] '+message, style)})
  }

  /**
   * Imposta un gruppo di log
   * @param message
   * @param styleParams
   */
  group(message, styleParams) {
    styleParams = (styleParams) ? styleParams : this.defaultBg;
    styleParams += this.styleParams;
    this._executeConsole(function(){console.group('%c [FC] '+message, styleParams)})
  }

  /**
   * Chiude il gruppo di log
   */
  groupEnd() {
    this._executeConsole(function(){console.groupEnd()});
  }
}

export default new FallcoConsole();

export { FallcoConsole };
